'use client';

import { lazy, Suspense, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Button } from '@packages/shared/src/ui/Button/Button';

const ActivateEmailLoginModal = lazy(() =>
  import('../ActivateEmailLogin/ActivateEmailLoginModal.client').then((mod) => ({
    default: mod.ActivateEmailLoginModal,
  })),
);

const messages = defineMessages({
  migrateTitle: {
    id: 'Login.migrate.title',
    defaultMessage: 'Mache dein Kundenkonto sicher!',
  },
  migrateDescription: {
    id: 'Login.migrate.description',
    defaultMessage:
      'Nutze den Login über E-Mail Adresse und Passwort, um dein Konto bestmöglich vor unbefugten Zugriffen zu schützen.',
  },
  migrateAction: {
    id: 'Login.migrate.action',
    defaultMessage: 'Du kannst den Zugang hier einrichten',
  },
});

export const CustomerNrLoginForm = () => {
  const { formatMessage } = useIntl();

  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <div className="border-color-grey flex items-center rounded-md border p-1">
      <span className="icon-emp-lock mx-2 size-4" />
      <div>
        <h6 className="font-bold">{formatMessage(messages.migrateTitle)}</h6>
        <span className="text-size-body3">{formatMessage(messages.migrateDescription)}</span>
        <div>
          <Button
            variant="textLink"
            className="hover:text-color-primary-light cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              setModalOpen(true);
            }}
          >
            {formatMessage(messages.migrateAction)}
          </Button>
        </div>
        {modalOpen && (
          <Suspense>
            <ActivateEmailLoginModal modalOpen={modalOpen} onClose={() => setModalOpen(false)} />
          </Suspense>
        )}
      </div>
    </div>
  );
};
